import { Injectable } from '@angular/core';
import { Permission } from './api/permission';
import { UserClientFullDTO } from './api/api';

@Injectable({
  providedIn: 'root',
})
export class PermissionService {
  public Permission = Permission;

  private _userPermissions: string[];

  constructor() {
    this._userPermissions = [];
  }

  set userPermissions(permissions: string[]) {
    this._userPermissions = permissions;
  }

  get userPermissions(): string[] {
    return this._userPermissions;
  }

  hasUserPermissions(permissions: string[], user: UserClientFullDTO): boolean {
    if (!user) {
      return false;
    }
    if (!permissions || permissions.length === 0) {
      return true;
    }

    for (const perm of permissions) {
      if (user.effectivePermissions.includes(perm)) {
        return true;
      }
    }

    return false;
  }

  hasPermission(permission: string): boolean {
    return this.hasPermissions([permission]);
  }

  hasPermissions(permissions: string[]): boolean {
    if (!this._userPermissions) {
      return false;
    }
    if (!permissions || permissions.length === 0) {
      return true;
    }

    for (const perm of permissions) {
      if (this._userPermissions.includes(perm)) {
        return true;
      }
    }

    return false;
  }
}
